export default __webpack_public_path__ + "14097103bbe3dbb1f164559797a4445e.svg";